<!--个人中心左侧公共导航 @zjf-2020-12-26-->
<template>
  <div>
    <MemberTitle :noHome="true" :memberTitle="title"></MemberTitle>
    <div class="sld_member_left_nav">
      <template v-for="(item, index) in leftNavMenu" :key="index">
        <!-- 如果 item.path 是外部链接，则使用 a 标签代替 router-link -->
        <!-- <a v-if="isExternalLink(item.path)" :href="item.path" target="_blank" class="menu" @click.stop>
          <span></span>
          <span>{{ item.name }}</span>
        </a> -->
        <router-link to="" class="menu">
          <!-- <router-link :to="{ path: item.path }" class="menu"></router-link> -->
          <!-- <i :class="{ iconfont: true, [item.icon]: true }"></i> -->
          <span></span>
          <span> {{ item.name }} </span>
        </router-link>
        <template v-if="item.child.length">
          <template v-for="(item_child, index_child) in item.child" :key="index_child">
            <!-- 判断子项是否为外部链接 -->
            <a v-if="isExternalLink(item_child.path)" @click.prevent="openExternalLink(item_child.path)"
              :class="{ submenu: true, cur_code_active: curCode == item_child.code }">
              {{ item_child.name }}
            </a>
            <router-link v-else-if="testIfShow(item_child) && isImplementedFeature(item_child)" :to="{ path: item_child.path, query: item_child.query }"
              :class="{ submenu: true, cur_code_active: curCode == item_child.code }">
              {{ item_child.name }}
            </router-link>
            <a v-else @click.prevent="showNotImplementedMsg" :class="{ submenu: true, cur_code_active: curCode == item_child.code }">
              {{ item_child.name }}
            </a>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, watchEffect, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import MemberTitle from '../components/MemberTitle'
import {
  ElMessage,
  ElDialog,
  ElButton,
  ElPopover,
  ElPopconfirm
} from 'element-plus'
export default {
  name: "MemberLeftNav",
  components: {
    MemberTitle
  },
  setup () {
    const store = useStore();
    const router = useRouter();
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const curCode = ref("");
    const memberInfo = ref(store.state.memberInfo);
    const title = ref("");
    const leftNavMenu = [
      {
        code: "member",
        icon: "icongerenzhongxinhuiyuanzhongxin",
        name: L["个人信息"],
        path: "/member/index",
        child: [
          {
            code: "MemberInfo",
            name: L["基本信息"],
            path: "/member/info"
          },
          {
            code: "memberAddressList",
            name: L["我的地址"],
            path: "/member/address/list"
          },
          {
            code: "MemberIdentifyConfirm",
            name: L["身份认证"],
            path: "/member/identifyConfirm"
          },
          {
            code: "MemberInvoice",
            name: L["发票信息"],
            path: "/member/invoice"
          },
          // {
          //   code: "memberAddressList",
          //   name: L["隐私设置"],
          //   path: "/member/address/list"
          // },
          // {
          //   code: "MemberPhoneMange",
          //   name: L["手机号管理"],
          //   path: "/member/phone"
          // },
          // {
          //   code: "memberEmailMange",
          //   name: L["邮箱管理"],
          //   path: "/member/email"
          // },
          // {
          //   code: "MemberLoginPassword",
          //   name: L["登录密码"],
          //   path: "/member/pwd/login"
          // },
          // {
          //   code: "MemberPayPassword",
          //   name: L["支付密码"],
          //   path: "/member/pwd/pay"
          // },
          // {
          //   code: "MemberResetPassword",
          //   name: L["重置密码"],
          //   path: "/member/pwd/reset"
          // },
          {
            code: "MemberAccount",
            name: L["账户安全"],
            path: "/member/account"
          },
        ]
      },
      {
        code: "message",
        icon: "icon-gerenzhongxinkehufuwu",
        name: L["我的消息"],
        path: "/member/index",
        child: [
          {
            code: "MsgList",
            name: L["消息中心"],
            path: "/member/msg/list"
          },
          {
            code: "MsgSetting",
            // query: { type: "return" },
            name: L["消息设置"],
            path: "/member/msg/setting"
          }
        ]
      },
      {
        code: "tarde",
        icon: "icon-gerenzhongxinjiaoyizhongxin",
        name: L["订单中心"],
        path: "/member/index",
        child: [
          {
            code: "memberOrderList",
            name: L["订单管理"],
            path: "/member/order/list"
          },
          {
            code: "AfterSales",
            name: L["售后管理"],
            path: "/member/order/aftersales"
            //path:"/member/order/refund/apply"
            //path:"/member/order/refund/detail"
          },
          {
            code: "MemberOrderEvaluation",
            name: L["评价管理"],
            path: "/member/order/evaluation"
            // path: "/member/order/evaluation"
          },
          // {
          //   code: "pointOrderList",
          //   name: "积分兑换订单",
          //   path: "/member/pointOrder/list"
          // },

          // {
          //   code: "AfterSalesListReturn",
          //   query: { type: "return" },
          //   name: L["我的退货"],
          //   //path: "/member/order/aftersales"
          //   path:"/member/order/refund/detail"
          // }
        ]
      },
      // {
      //   code: "collect",
      //   icon: "icongerenzhongxinguanzhu",
      //   name: L["关注中心"],
      //   path: "/member/index",
      //   child: [

      //     {
      //       code: "memberCollectStore",
      //       query: { type: "store" },
      //       name: L["关注店铺"],
      //       path: "/member/collect"
      //     },
      //     {
      //       code: "MemberFootprint",
      //       name: L["我的足迹"],
      //       path: "/member/footprint"
      //     }
      //   ]
      // },
      // {
      //   code: "service",
      //   icon: "icon-gerenzhongxinkehufuwu",
      //   name: L["客户服务"],
      //   path: "/member/index",
      //   child: [
      //     {
      //       code: "AfterSalesList",
      //       name: L["我的退款"],
      //       path: "/member/order/aftersales"
      //     },
      //     {
      //       code: "AfterSalesListReturn",
      //       query: { type: "return" },
      //       name: L["我的退货"],
      //       path: "/member/order/aftersales"
      //     }
      //   ]
      // },

      {
        code: "money",
        icon: "icongerenzhongxincaichanzhongxin",
        name: L["我的账户"],
        path: "/member/index",
        child: [
          {
            code: "MyPoint",
            name: "我的积分",
            path: "/member/myPoint"
          },
          {
            code: "MemberCoupon",
            name: "我的优惠券",        
            path: "/member/coupon"
          },
          {
            code: "ABuy",
            name: "A码购",
            path: "/member/Acode/list"
            // path: "/member/coupon"
          },
          // {
          //   code: "MemberCoupon",
          //   name: "中奖记录",
          //   path: "/member/coupon"
          // },
          {
            code: "MemberCollect",
            name: L["收藏商品"],
            path: "/member/collect"
          },
          // {
          //   code: "MemberBalance",
          //   name: L["我的余额"],
          //   path: "/member/balance"
          // },
          // {
          //   code: "MemberRecharge",
          //   name: L["账户充值"],
          //   path: "/member/recharge"
          // }
        ]
      },
      {
        code: "service",
        icon: "icon-gerenzhongxinkehufuwu",
        name: L["服务中心"],
        path: "/member/index",
        child: [
          {
            code: "NetSearch",
            name: L["网点查询"],
            path: "https://www.asus.com.cn/support/service-center/chinese%20mainland/#"
          },
          {
            code: "ServiceSearch",
            name: L["服务查询"],
            path: "https://www.asus.com.cn/support/service-center/chinese%20mainland/"
          },
          {
            code: "Transaction",
            name: L["交易纠纷"],
            path: "https://asus.jinshuju.net/f/oSxwdr"
          },
          {
            code: "OldToNew",
            name: L["以旧换新"],
            path: "https://asus.youdemai.com/product/product/index?uid=asusUser"
          },
          {
            code: "Survey",
            name: L["调研"],
            path: "https://asus.jinshuju.net/f/ueasIk?x_field_1=华硕商城PC"
          }
        ]
      },
    ];

    const findMenuItemByPath = (menu, curPath) => {
      let result = null;

      function search (item) {
        if (item.path === curPath) {
          return item;
        }
        if (item.child && item.child.length > 0) {
          for (let childItem of item.child) {
            const found = search(childItem);
            if (found) return found;
          }
        }
        return null;
      }

      for (let item of menu) {
        const found = search(item);
        if (found) {
          result = found;
          break;
        }
      }

      return result;
    }


    watchEffect(() => {
      let tmpPath = router.currentRoute.value.fullPath;

      if (
        router.currentRoute.value.name != undefined &&
        router.currentRoute.value.name
      ) {

        let routerItem = findMenuItemByPath(leftNavMenu, router.currentRoute.value.path)
        if (routerItem) {
          title.value = routerItem.name
        }

        curCode.value = router.currentRoute.value.name;
        if (tmpPath == "/member/collect?type=store") {
          curCode.value = "memberCollectStore"; //关注店铺
        } else if (
          tmpPath.indexOf("/member/order/aftersales") > -1 ||
          tmpPath.indexOf("/member/order/refund/apply") > -1 ||
          tmpPath.indexOf("/member/order/refund/detail") > -1
        ) {
          curCode.value = "AfterSales"; //我的退款
        }
        else if (
          tmpPath.indexOf("/member/Acode/list") > -1
        ) {
          curCode.value = "ABuy"; //我的退款
        }
      }
    });
    const testIfShow = nav_info => {
      if (nav_info.code == "MemberResetPassword") {
        if (store.state.memberInfo.hasPayPassword == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    };
    // 判断是否为外部链接
    const isExternalLink = (path) => {
      return /^https?:\/\//i.test(path);
    };
    const openExternalLink = (url) => {
      window.open(url, '_blank');
    };

    const showNotImplementedMsg = () => {
      ElMessage('功能暂未实现')
    };

    const isImplementedFeature = (menuItem) => {
      const implementedPaths = [
        "/member/info", "/member/address/list", "/member/account",
        "/member/order/list", "/member/order/aftersales", "/member/collect","/member/coupon",
        "/member/identifyConfirm", "/member/invoice", "/member/myPoint",
        "/member/Acode/list", "/member/order/evaluation", "/member/msg/list",
        "/member/msg/setting"// 已实现的路径列表，请根据实际情况添加
      ];
      return implementedPaths.includes(menuItem.path);
    };

    return {
      leftNavMenu,
      isExternalLink,
      openExternalLink,
      showNotImplementedMsg,
      isImplementedFeature,
      curCode, memberInfo, testIfShow, L, title
    };
  }
};
</script>

<style lang="scss" scoped>
.sld_member_left_nav {
  float: left;
  width: 220px;
  color: #666;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  background-color: #fff;
  // border: 1px solid #ebebeb;
  // border-top: 1px solid #fff;
  margin-top: -1px;
  margin-bottom: 20px;
  padding-bottom: 40px;

  .menu {
    display: flex;
    align-items: center;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    line-height: 26px;
    text-align: left;
    padding-bottom: 10px;
    padding-left: 27px;
    padding-top: 25px;
    // border-top: 1px solid #ebebeb;

    > :nth-child(1) {
      width: 3px;
      height: 14px;
      background: #1e7cff;
      margin-right: 10px;
    }

    i {
      color: #888;
      font-size: 16px;
      font-weight: 400;
      margin-right: 5px;
    }
  }

  .submenu {
    display: block;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.7);
    line-height: 22px;
    text-align: left;
    padding: 9px 0 9px 40px;

    &:hover {
      color: #ffffff;
      background: #1e7cff;
      cursor: pointer;
    }

    &.cur_code_active {
      color: #ffffff;
      background: #1e7cff;
    }
  }
}
</style>